import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import "./centralAppointmentCancel.css";
import { CancelModal } from "./CancelModal";

export const CentralAppointmentCancel = () => {
    const { hospitalId } = useParams();
    const [appointmentStatus, setAppointmentStatus] = useState("active");
    const [showCancelModal, setShowCancelModal] = useState(false);

    const handleModalClose = useCallback(() => {
        setShowCancelModal(false);
    }, []);

    const handleChange = useCallback((event) => {
        try {
            const value = event.target.value;
            if (value === "cancel") {
                setShowCancelModal(true);
            } else {
                setAppointmentStatus(value);
            }
        } catch (error) {
            console.error('Error handling status change:', error);
        }
    }, []);

    // Get class based on status
    const getStatusClass = (status) => {
        switch (status) {
            case 'active':
                return 'status-active';
            case 'cancel':
                return 'status-cancel';
            default:
                return '';
        }
    };

    return (
        <div className="containerClass">
            <div className="textReadOnlyRow">
                <span className="textReadOnlyLabel">Appointment Status</span>
                <span className="textReadOnlyValue">
                    <select
                        value={appointmentStatus}
                        onChange={handleChange}
                        className={`appointmentDropdown ${getStatusClass(appointmentStatus)}`}
                        aria-label="Appointment Status"
                    >
                        <option value="active" className="status-active">Active</option>
                        <option value="cancel" className="status-cancel">Cancel</option>
                    </select>
                </span>
            </div>

            {showCancelModal && (
                <CancelModal 
                    onClose={handleModalClose}
                    hospitalId={hospitalId}
                />
            )}
        </div>
    );
};
